<script>

    import { AccountStore } from '../stores'

    import Modal from '../$components/modal.svelte'
    import Accounts from '../accounts/accounts.svelte'
    import AccountRead from '../accounts/account.svelte'

    import ShipmentsReport from '../accounts/account.shipments.report.svelte'
    import ChargesReport from '../accounts/account.charges.report.svelte'
    import RefundsReport from '../accounts/account.refunds.report.svelte'

</script>

<Accounts />
 
<Modal id="AccountRead" title="Información cuenta" >
    <AccountRead on:deleted={AccountStore.modalClose} />
    <hr>
    <div class="columns">
        <div class="column">
            <ShipmentsReport />
        </div>
        <div class="column">
            <ChargesReport />
        </div>
        <div class="column">
            <RefundsReport />
        </div>
    </div>
</Modal>